<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Configuración</p>
              <argon-button
                color="success"
                size="sm"
                class="ms-auto"
                @click="save"
                :disabled="isSaving"
              >
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información de la empresa</p>
            <div class="row">
              <div class="col-md-12">
                <label class="form-control-label">Nombre de la empresa</label>
                <argon-input type="text" v-model="form.company_name" placeholder="Ej: Mi Empresa" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">NIT</label>
                <argon-input type="text" v-model="form.nit" placeholder="Número de identificación tributaria" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Descripción</label>
                <textarea
                  class="form-control"
                  v-model="form.description"
                  rows="3"
                  placeholder="Descripción o notas"
                ></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="form.email" placeholder="contacto@empresa.com" />
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="form.phone" placeholder="+57 300 123 4567" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" placeholder="Dirección física" />
              </div>

              <div class="col-md-12">
                <label class="form-control-label">TRM dólar (peso a dólar)</label>
                <argon-input
                  type="number"
                  v-model="form.dollar_rate"
                  min="0"
                  step="0.01"
                  placeholder="Cuántos pesos vale un dólar. Ej: 4000"
                />
                <p class="text-muted text-xs mb-0 mt-1">
                  Se usa para mostrar el precio en dólares (USD) en el catálogo público. Deja en 0 para ocultarlo.
                </p>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Catálogo público</p>
                <label class="form-control-label">Descuento general de la tienda (%)</label>
                <argon-input
                  type="number"
                  v-model="form.store_discount_percent"
                  placeholder="0"
                />
                <p class="text-muted text-xs mb-3 mt-n2">
                  Se aplica a todos los productos del catálogo. Si un producto tiene su propio descuento
                  en Inventario, se usa el del producto. Deja en 0 para no aplicar descuento.
                </p>

                <label class="form-control-label">Banners de promoción (carrusel antes de "Catálogo Mayorista")</label>
                <p class="text-muted text-xs mb-2">
                  Hasta 2 banners. Cada uno lleva una imagen para PC (recomendado 1920 × 600 px) y otra para
                  celular (recomendado 1080 × 1080 px). Si falta una de las dos se usa la otra.
                </p>
                <div v-for="(b, i) in banners" :key="'banner' + i" class="border border-radius-lg p-3 mb-3">
                  <p class="text-sm font-weight-bold mb-2">Banner {{ i + 1 }}</p>
                  <div class="row">
                    <div v-for="kind in ['desktop', 'mobile']" :key="kind" class="col-md-6 mb-2">
                      <label class="form-control-label">{{ kind === 'desktop' ? 'Imagen PC' : 'Imagen celular' }}</label>
                      <div v-if="bannerPreview(i, kind)" class="mb-2 position-relative">
                        <img
                          :src="bannerPreview(i, kind)"
                          alt=""
                          class="w-100 border-radius-md"
                          :style="{ maxHeight: '140px', objectFit: 'contain', background: '#f6f6f6' }"
                        />
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger mt-1 mb-0"
                          @click="removeBanner(i, kind)"
                        >
                          Quitar
                        </button>
                      </div>
                      <input
                        type="file"
                        class="form-control"
                        accept="image/*"
                        @change="onBannerChange(i, kind, $event)"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">ConEnvios (guías de envío)</p>
                <div class="d-flex align-items-center mb-3">
                  <label class="form-control-label mb-0">Activar integración</label>
                  <div class="form-check form-switch ms-3 mb-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.conenvios_enabled"
                    />
                    <label class="form-check-label">Activa</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Correo del API</label>
                    <argon-input
                      type="email"
                      v-model="form.conenvios_email"
                      placeholder="correo@empresa.com"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Clave del API</label>
                    <input
                      type="password"
                      class="form-control"
                      v-model="form.conenvios_password"
                      :placeholder="hasConenviosPassword ? '•••••••• (dejar igual para no cambiar)' : 'Clave del API de ConEnvios'"
                      autocomplete="new-password"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center">
                  <label class="form-control-label mb-0">Beneficios de tareas</label>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.benefits_of_tasks"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Logos (opcional)</p>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo claro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoLightChange"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo oscuro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoDarkChange"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center mb-3">
                  <p class="text-uppercase text-sm mb-0">Shopify</p>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.shopify_active"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
                <div v-if="form.shopify_active" class="row">
                  <div class="col-md-12">
                    <label class="form-control-label">Dominio de la tienda</label>
                    <argon-input
                      type="text"
                      v-model="form.shopify_domain"
                      placeholder="tienda.myshopify.com"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Client ID</label>
                    <argon-input
                      type="text"
                      v-model="form.shopify_client_id"
                      placeholder="Client ID"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Client Secret</label>
                    <argon-input
                      type="password"
                      v-model="form.shopify_client_secret"
                      placeholder="Client Secret"
                    />
                  </div>
                  <div class="col-md-12 d-flex align-items-center gap-3 mt-2">
                    <argon-button
                      color="info"
                      size="sm"
                      @click="generateShopifyToken"
                      :disabled="isGeneratingToken"
                    >
                      {{ isGeneratingToken ? 'Generando...' : 'Generar token' }}
                    </argon-button>
                    <span v-if="form.shopify_access_token" class="text-xs text-success">
                      <i class="fa fa-check-circle"></i> Token guardado
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center mb-3">
                  <p class="text-uppercase text-sm mb-0">Integración kubApp</p>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.kubapp_active"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
                <div v-if="form.kubapp_active" class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Correo / Usuario</label>
                    <argon-input
                      type="text"
                      v-model="form.kubapp_user_id"
                      placeholder="usuario@dominio"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Clave</label>
                    <argon-input
                      type="password"
                      v-model="form.kubapp_passwd"
                      placeholder="Contraseña de kubApp"
                    />
                  </div>
                  <div class="col-md-12 d-flex align-items-center gap-3 mt-2">
                    <argon-button
                      color="info"
                      size="sm"
                      @click="generateKubappToken"
                      :disabled="isGeneratingKubappToken"
                    >
                      {{ isGeneratingKubappToken ? 'Generando...' : 'Generar token' }}
                    </argon-button>
                    <span v-if="form.kubapp_access_token" class="text-xs text-success">
                      <i class="fa fa-check-circle"></i> Token guardado
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from "sweetalert2";

export default {
  name: "Settings",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      isSaving: false,
      form: {
        company_name: "",
        nit: "",
        description: "",
        email: "",
        phone: "",
        address: "",
        dollar_rate: 0,
        store_discount_percent: 0,
        conenvios_enabled: false,
        conenvios_email: "",
        conenvios_password: "",
        benefits_of_tasks: false,
        shopify_active: false,
        shopify_domain: "",
        shopify_client_id: "",
        shopify_client_secret: "",
        shopify_access_token: "",
        kubapp_active: false,
        kubapp_user_id: "",
        kubapp_passwd: "",
        kubapp_access_token: "",
      },
      logoLightFile: null,
      logoDarkFile: null,
      // Banners del catálogo: ruta guardada, archivo nuevo, vista previa local y marca de borrado
      banners: [this.emptyBanner(), this.emptyBanner()],
      hasConenviosPassword: false,
      isGeneratingToken: false,
      isGeneratingKubappToken: false,
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        const data = response.data;
        this.hasConenviosPassword = !!data.has_conenvios_password;
        this.form = {
          company_name: data.company_name || "",
          nit: data.nit || "",
          description: data.description || "",
          email: data.email || "",
          phone: data.phone || "",
          address: data.address || "",
          dollar_rate: data.dollar_rate ? Number(data.dollar_rate) : 0,
          store_discount_percent: data.store_discount_percent ? Number(data.store_discount_percent) : 0,
          conenvios_enabled: !!data.conenvios_enabled,
          conenvios_email: data.conenvios_email || "",
          conenvios_password: "",
          benefits_of_tasks: !!data.benefits_of_tasks,
          shopify_active: !!data.shopify_active,
          shopify_domain: data.shopify_domain || "",
          shopify_client_id: data.shopify_client_id || "",
          shopify_client_secret: data.shopify_client_secret || "",
          shopify_access_token: data.shopify_access_token || "",
          kubapp_active: !!data.kubapp_active,
          kubapp_user_id: data.kubapp_user_id || "",
          kubapp_passwd: "",
          kubapp_access_token: data.kubapp_access_token || "",
        };
        this.banners = [0, 1].map((i) => {
          const saved = (data.catalog_banners || [])[i] || {};
          return {
            ...this.emptyBanner(),
            desktop: { ...this.emptyBanner().desktop, path: saved.desktop || null },
            mobile: { ...this.emptyBanner().mobile, path: saved.mobile || null },
          };
        });
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
        await Swal.fire("Error", "Error al cargar la configuración", "error");
      }
    },
    onLogoLightChange(event) {
      this.logoLightFile = event.target.files?.[0] || null;
    },
    onLogoDarkChange(event) {
      this.logoDarkFile = event.target.files?.[0] || null;
    },
    emptyBanner() {
      return {
        desktop: { path: null, file: null, preview: null, remove: false },
        mobile: { path: null, file: null, preview: null, remove: false },
      };
    },
    bannerPreview(i, kind) {
      const slot = this.banners[i][kind];
      if (slot.preview) return slot.preview;
      if (slot.path && !slot.remove) {
        const base = (process.env.VUE_APP_API_IMAGE_URL || "").replace(/\/?$/, "/");
        return base + String(slot.path).replace(/^\/+/, "");
      }
      return null;
    },
    onBannerChange(i, kind, event) {
      const slot = this.banners[i][kind];
      const file = event.target.files?.[0] || null;
      if (slot.preview) URL.revokeObjectURL(slot.preview);
      slot.file = file;
      slot.preview = file ? URL.createObjectURL(file) : null;
      slot.remove = false;
    },
    removeBanner(i, kind) {
      const slot = this.banners[i][kind];
      if (slot.preview) URL.revokeObjectURL(slot.preview);
      slot.file = null;
      slot.preview = null;
      slot.remove = !!slot.path;
    },
    async generateShopifyToken() {
      this.isGeneratingToken = true;
      try {
        const response = await this.$store.dispatch("settings/generateShopifyToken");
        this.form.shopify_access_token = response.data.access_token || "";
        await Swal.fire("Éxito", response.data.message || "Token generado correctamente", "success");
        this.loadSettings();
      } catch (error) {
        console.error("Error al generar token Shopify:", error);
        await Swal.fire(
          "Error",
          error?.data?.message || "Error al generar el token de Shopify",
          "error"
        );
      } finally {
        this.isGeneratingToken = false;
      }
    },
    async generateKubappToken() {
      this.isGeneratingKubappToken = true;
      try {
        const response = await this.$store.dispatch("settings/generateKubappToken");
        this.form.kubapp_access_token = response.data.access_token || "";
        await Swal.fire("Éxito", response.data.message || "Token generado correctamente", "success");
        this.loadSettings();
      } catch (error) {
        console.error("Error al generar token kubApp:", error);
        await Swal.fire(
          "Error",
          error?.data?.message || "Error al generar el token de kubApp",
          "error"
        );
      } finally {
        this.isGeneratingKubappToken = false;
      }
    },
    async save() {
      this.isSaving = true;
      try {
        const formData = new FormData();
        formData.append("company_name", this.form.company_name);
        formData.append("nit", this.form.nit ?? "");
        formData.append("description", this.form.description);
        formData.append("email", this.form.email);
        formData.append("phone", this.form.phone);
        formData.append("address", this.form.address);
        formData.append("dollar_rate", this.form.dollar_rate ?? 0);
        formData.append("store_discount_percent", this.form.store_discount_percent || 0);
        this.banners.forEach((b, i) => {
          ["desktop", "mobile"].forEach((kind) => {
            if (b[kind].file) {
              formData.append(`banner_${i}_${kind}`, b[kind].file);
            } else if (b[kind].remove) {
              formData.append(`remove_banner_${i}_${kind}`, "1");
            }
          });
        });
        formData.append("conenvios_enabled", this.form.conenvios_enabled ? "1" : "0");
        formData.append("conenvios_email", this.form.conenvios_email || "");
        if (this.form.conenvios_password) {
          formData.append("conenvios_password", this.form.conenvios_password);
        }
        formData.append("benefits_of_tasks", this.form.benefits_of_tasks ? "1" : "0");
        formData.append("shopify_active", this.form.shopify_active ? "1" : "0");
        formData.append("shopify_domain", this.form.shopify_domain || "");
        formData.append("shopify_client_id", this.form.shopify_client_id || "");
        formData.append("shopify_client_secret", this.form.shopify_client_secret || "");
        formData.append("kubapp_active", this.form.kubapp_active ? "1" : "0");
        formData.append("kubapp_user_id", this.form.kubapp_user_id || "");
        if (this.form.kubapp_passwd) {
          formData.append("kubapp_passwd", this.form.kubapp_passwd);
        }
        if (this.logoLightFile) {
          formData.append("logo_path", this.logoLightFile);
        }
        if (this.logoDarkFile) {
          formData.append("logo_path_dark", this.logoDarkFile);
        }

        await this.$store.dispatch("settings/save", formData);
        await Swal.fire("Éxito", "Configuración guardada correctamente", "success");
        this.logoLightFile = null;
        this.logoDarkFile = null;
        this.form.conenvios_password = "";
        if (formData.get("conenvios_password")) {
          this.hasConenviosPassword = true;
        }
        document.querySelectorAll('input[type="file"]').forEach((el) => (el.value = ""));
        this.loadSettings();
      } catch (error) {
        console.error("Error al guardar:", error);
        await Swal.fire(
          "Error",
          error?.response?.data?.message || "Error al guardar la configuración",
          "error"
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
